'use strict';

const $ = require('jquery');

/**
 * Event Handler for removing an item from the Wishlist
 *
 * @param {Event} event
 */
const clickRemoveItemHandler = function (event) {
    const $link = $(event.currentTarget);
    const $miniWishlistContainer = $('li.nav-item-wishlist');

    const url = $link.attr('href');
    const pid = $link.data('pid');

    event.preventDefault();
    if (url && pid) {
        $.ajax({
            url: url,
            data: pid
        }).done(function (res) {
            $miniWishlistContainer.html(res);
        });
    }
};

/**
 * Fetches the current MiniWishlist content through AJAX
 */
function updateMiniWishlist() {
    const $link = $('#ajax-wishlist');
    const url = $link.data('ajax-url');

    $.ajax({
        url: url,
        data: {
            onlyFlyout: true
        }
    })
        .done(function (res) {
            $('#ajax-wishlist').html(res);
        })
        .fail(function () {
            /**
             * @TODO No UX requirements for this case at the moment
             */
            $('#ajax-wishlist').html('');
        });
}

/**
 * Initialize Wishlist-related Event listeners
 */
function initializeEvents() {
    $('.header-main-right').on('click', '.wish-list-remove .remove-product', clickRemoveItemHandler);
    $('div.mini-whishlist-total').on('mouseenter', updateMiniWishlist);
    $('.nav-item-wishlist .menus-flyout-arrow-wrapper').on('keydown', function (event) {
        // Space or Enter
        if (event.keyCode === 32 || event.keyCode === 13) {
            updateMiniWishlist();
        }
    });
}

const miniwishlist = {
    /**
     * Init function for the Wishlist module
     */
    init: function () {
        initializeEvents();
    }
};

module.exports = miniwishlist;
